import { round } from 'src/utils/number';

const LB_UOM = 'LB';

export const normalizeUom = (uom: string | null | undefined): string =>
  String(uom ?? '')
    .trim()
    .toUpperCase();

export const isLbUom = (uom: string | null | undefined): boolean => normalizeUom(uom) === LB_UOM;

export const getPriceDecimalPlaces = (uom: string | null | undefined): number =>
  isLbUom(uom) ? 3 : 2;

export const getPriceCurrencyFormat = (uom: string | null | undefined): string =>
  isLbUom(uom) ? '{0:c3}' : '{0:c2}';

export const formatPriceValueByUom = (
  price: string | number | null | undefined,
  uom: string | null | undefined
): string => {
  if (price == null || price === '' || price === '-') {
    return '';
  }

  const numericPrice = Number(price);
  if (!Number.isFinite(numericPrice)) {
    return String(price);
  }

  const decimals = getPriceDecimalPlaces(uom);
  return round(numericPrice, decimals).toFixed(decimals);
};
